// extracted by css-extract-rspack-plugin
export default {"wrapper":"BE_jLLthaZwtTvHg","input":"DTpeBsROVuEhA9d_","label":"qj2CCFX5DRIXzrTj"};